import React from 'react';
import { Link } from 'react-router-dom';
import { ChefHat, ShieldCheck, Mail, MessageSquare, MapPin } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="bg-maroon-dark text-white border-t border-white/5 py-12 px-4 md:px-6 grain">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-8">
        
        {/* Brand section */}
        <div className="space-y-4">
          <Link to="/" state={{ fromFooter: true }} className="flex items-center gap-2 group">
            <div className="w-10 h-10 rounded-full bg-gradient-primary flex items-center justify-center shadow-warm">
              <img src="/pushpanjaliLogoMain.png" alt="Logo" className="w-full h-full object-contain" />
              {/* <ChefHat className="w-5 h-5 text-white" /> */}
            </div>
            <div>
              <h2 className="font-heading font-bold text-xl text-white">Pushpanjali</h2>
              <p className="text-golden text-xs font-body">Authentic • Fresh • Homemade</p>
            </div>
          </Link>
          <p className="text-xs text-white/70 font-body leading-relaxed max-w-xs">
            A premium cloud kitchen in Noida delivering slow-cooked, hygienically prepared meals directly to your doorstep. Real home recipes, zero preservatives.
          </p>
          <div className="flex items-center gap-2 border border-white/10 rounded-xl px-3 py-2 bg-white/5 w-fit">
            <ShieldCheck className="w-4 h-4 text-golden" />
            <div className="text-[10px] text-white/80 font-body">FSSAI Lic No. 22724441000624</div>
          </div>
        </div>

        {/* Quick Links */}
        <div>
          <h3 className="font-heading font-extrabold text-sm uppercase tracking-wider text-golden mb-4">Quick Links</h3>
          <ul className="space-y-2.5 text-sm font-body text-white/80">
            <li><Link to="/" state={{ fromFooter: true }} className="hover:text-golden transition-colors">Home</Link></li>
            <li><Link to="/menu" state={{ fromFooter: true }} className="hover:text-golden transition-colors">Explore Menu</Link></li>
            <li><Link to="/orders" state={{ fromFooter: true }} className="hover:text-golden transition-colors">My Orders</Link></li>
            <li><Link to="/profile" state={{ fromFooter: true }} className="hover:text-golden transition-colors">My Profile</Link></li>
          </ul>
        </div>

        {/* Legal Policy Links */}
        <div>
          <h3 className="font-heading font-extrabold text-sm uppercase tracking-wider text-golden mb-4">Customer Care</h3>
          <ul className="space-y-2.5 text-sm font-body text-white/80">
            <li><Link to="/contact" state={{ fromFooter: true }} className="hover:text-golden transition-colors">Contact Us</Link></li>
            <li><Link to="/privacy" state={{ fromFooter: true }} className="hover:text-golden transition-colors">Privacy Policy</Link></li>
            <li><Link to="/terms" state={{ fromFooter: true }} className="hover:text-golden transition-colors">Terms & Conditions</Link></li>
            <li><Link to="/refund" state={{ fromFooter: true }} className="hover:text-golden transition-colors">Return & Refund Policy</Link></li>
          </ul>
        </div>

        {/* Help & Operations */}
        <div className="space-y-4">
          <h3 className="font-heading font-extrabold text-sm uppercase tracking-wider text-golden mb-4">Get In Touch</h3>
          <ul className="space-y-3 text-sm font-body text-white/80">
            <li className="flex items-center gap-2">
              <Mail className="w-4 h-4 text-golden shrink-0" />
              <a href="mailto:contact@pushpanjali.cloud" className="hover:text-golden transition-colors">
                contact@pushpanjali.cloud
              </a>
            </li>
            <li className="flex items-center gap-2">
              <MessageSquare className="w-4 h-4 text-golden shrink-0" />
              <a href="https://wa.me/919999999999" target="_blank" rel="noopener noreferrer" className="hover:text-golden transition-colors">
                WhatsApp Support
              </a>
            </li>
            <li className="flex items-center gap-2">
              <MapPin className="w-4 h-4 text-golden shrink-0" />
              <span>Noida, Uttar Pradesh, India</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto border-t border-white/10 mt-10 pt-6 flex flex-col md:flex-row items-center justify-between text-xs text-white/50 font-body gap-4">
        <div>
          © {new Date().getFullYear()} Pushpanjali.cloud. All rights reserved.
        </div>
        <div className="flex gap-6">
          <span>Freshly cooked in Noida</span>
        </div>
      </div>
    </footer>
  );
}
